import { Icon, Row, Col, Flex, Text } from "@/base/index";
import EmailSvg from "../../static/footer-contacts-email.svg?react";
import PhoneSvg from "../../static/footer-contacts-phone.svg?react";
import DirectionSvg from "../../static/footer-contacts-direction.svg?react";

const contactsInfoItems = [
  {
    icon: PhoneSvg,
    href: "tel:4123060640",
    target: "_self",
    text: "412 306 0640",
  },
  {
    icon: EmailSvg,
    href: "mailto:info@petrosoftinc.com",
    target: "_self",
    text: "Contact via Email",
  },
  {
    icon: DirectionSvg,
    href: "https://www.google.com/maps/place/Petrosoft,+LLC/@40.4543841,-80.1037207,17z/data=!4m13!1m7!3m6!1s0x88345f54e7871be9:0x20b79959c7d215d6!2s290+Bilmar+Dr,+Pittsburgh,+PA+15205!3b1!8m2!3d40.45438!4d-80.101532!3m4!1s0x0:0x3ee32b8379de5ffe!8m2!3d40.4535683!4d-80.1020057",
    target: "_blank",
    text: "Get Directions",
  },
];

export const FooterContactsInfo = () => {
  return (
    <Row align="middle" gutter={[32, 12]}>
      {contactsInfoItems.map((item: any, key: any) => (
        <Col key={key} xs={{ flex: "none" }}>
          <a href={item.href} target={item.target}>
            <Flex gap={8} wrap="nowrap" justify="flex-start">
              <Icon size={24} component={item.icon} />
              <Text strong>{item.text}</Text>
            </Flex>
          </a>
        </Col>
      ))}
    </Row>
  );
};
